common.View.create('website::layouts.Main', {

    loaded: false,

    onDOMLoad() {
        this.initAnimations();

        if (window.location.pathname === '/') {
            this.initHeader();
        }

        this.initMegaMenu();
    },

    initHeader() {
        if($('.canvas-blocks-custom-headerVideo-Block video').get(0)) {

            setInterval(() => {
                this.setupVideo();
            }, 1000 / 24);

        }
    },

    setupVideo(force = false) {
        let frameTime = $('.canvas-blocks-custom-headerVideo-Block video').get(0).currentTime;

        // Always a 0 frame on replay.
        if (frameTime >= 0.01 && frameTime <= 3.95) {
            this.setupBlackMenu();
        }

        // Set classes on specific time.
        if (frameTime >= 3.95 && frameTime <= 11.47) {
            this.setupWhiteMenu(force);
        }

        // Set classes on specific time.
        if (frameTime >= 11.47 && frameTime <= 15.4) {
            this.setupBlackMenu();
        }

        // Set classes on specific time.
        if (frameTime >= 15.4 && frameTime <= 18.2) {
            this.setupWhiteMenu(force);

            // Show the button on desktop
            if (window.innerWidth >= 768) {
                $('.canvas-blocks-custom-headerVideo-Block div.headerButton').removeClass('hidden');
            }
        }

        // Set classes on specific time.
        if(frameTime > 18.45) {
            // Hide the button again.
            if (window.innerWidth >= 768) {
                $('.canvas-blocks-custom-headerVideo-Block div.headerButton').addClass('hidden');
            }
        }
    },

    setupBlackMenu() {
        if(!$('.website\\:\\:partials-menu-LevelNavbar').hasClass('blackMenu') || !$('.website\\:\\:layouts-main-Header div.mobile-nav').hasClass('blackMobileMenu')) {
            $('.website\\:\\:layouts-main-Header a.logo img').attr('src', '/img/common/Laveto_RGB.svg');
            $('.website\\:\\:partials-menu-LevelNavbar').addClass('blackMenu');

            // Mobile
            $('.website\\:\\:layouts-main-Header a.mobileLogo img').attr('src', '/img/common/Laveto_RGB.svg');
            $('.website\\:\\:layouts-main-Header div.mobile-nav').addClass('blackMobileMenu'); // Kinda useless but indicates we are on mobile.
            $('.website\\:\\:layouts-main-Header button.hamburger .hamburger-box .hamburger-inner').removeClass('bg-white').addClass('bg-black');
        }
    },

    setupWhiteMenu(force) {
        if($('.website\\:\\:partials-menu-LevelNavbar').hasClass('hoverMenu')) {
            return;
        }

        if(force || $('.website\\:\\:partials-menu-LevelNavbar').hasClass('blackMenu') || $('.website\\:\\:layouts-main-Header div.mobile-nav').hasClass('blackMobileMenu')) {
            $('.website\\:\\:partials-menu-LevelNavbar').removeClass('blackMenu');
            $('.website\\:\\:layouts-main-Header a.logo img').attr('src', '/img/common/lavlogo-white.svg');

            // Mobile
            $('.website\\:\\:layouts-main-Header div.mobile-nav').removeClass('blackMobileMenu'); // Kinda useless but indicates we are on mobile.
            $('.website\\:\\:layouts-main-Header a.mobileLogo img').attr('src', '/img/common/lavlogo-white.svg');
            $('.website\\:\\:layouts-main-Header button.hamburger .hamburger-box .hamburger-inner').removeClass('bg-black').addClass('bg-white');
        }
    },

    initMegaMenu() {
        $('.navbar-nav .nav-item').hover((event) => {
            if($(event.currentTarget).find('> .dropdown-toggle').length) {
                $('.website\\:\\:partials-menu-LevelNavbar').addClass('hoverMenu');
                $('.website\\:\\:layouts-main-Header a.logo img').attr('src', '/img/common/Laveto_RGB.svg');
            }
        }, (event) => {
            $('.website\\:\\:partials-menu-LevelNavbar').removeClass('hoverMenu');

            if (window.location.pathname !== '/') {
                $('.website\\:\\:layouts-main-Header a.logo img').attr('src', '/img/common/lavlogo-white.svg');
            } else {
                this.setupVideo(true);
            }
        });
    },

    initAnimations() {
        let sal = require('sal.js');

        sal({
            threshold: 0.1,
            once: true,
        });
    },
});
